export { default as EnOverlayBadge } from './EnOverlayBadge.vue';
